// extracted by mini-css-extract-plugin
export var button = "_1d-1";
export var featuredLink = "_1d-4";
export var spinner = "_1d-2";
export var spinnerContainer = "_1d-3";
export var text = "_1d-0";